<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
    <section class="content-wrapper">
        <div class="offer_box-wrapper">
            <div class="offer_box">
                <div class="offer_box01">
                    <h2 class="offer_box-company">{{ companyInfo.company_name}}</h2>
                    <div class="offer_box-about">
                        <p><img :src="companyInfo.company_logo" class="offer_box-img"></p>
                        <p><a :href="companyInfo.company_url" target="_blank" class="offer_box-link">{{ companyInfo.company_url | urlencode }}</a></p>
                    </div>
                    <div class="offer_box-message">
                        <p v-html="companyInfo.company_introduction"></p>
                    </div>
                    <br>
                    <div class="offer_box-message offer_box-pdf" v-if="false">
                        <p>添付ファイル： </p>
                        <p>
                            <a href="" target="_blank">企業紹介.pdf</a><br>
                            <a href="" target="_blank">色々.pdf</a><br>
                            <a href="" target="_blank">なんか.pdf</a>
                        </p>
                    </div>
                    <div class="text-center">
                        <el-button id="resend_secure" type="success" class="offer_box-acceptbtn"
                        @click="submitYagioffer()"
                          >まずは話を聞いてみる</el-button>
                    </div>
                </div>
                <div class="offer_box02">
                    <div class="offer_box-list">
                        <p class="offer_box-title">企業タイプ</p>
                        <p class="offer_box-txt">{{ companyInfo.company_size}}</p>
                    </div>
                    <div class="offer_box-list">
                        <p class="offer_box-title">勤務環境</p>
                        <p v-for="(item, index) in companyInfo.work_environment" :key="index"  class="offer_box-txt">{{ item.value }}</p>
                    </div>
                    <div class="offer_box-list">
                        <p class="offer_box-title">予定勤務地</p>
                        <p v-for="(item, index) in companyInfo.work_place" :key="index" class="offer_box-txt">{{ item.value }}</p>
                    </div>
                    <div class="offer_box-list">
                        <p class="offer_box-title">業種</p>
                        <p v-for="(item, index) in companyInfo.industry" :key="index" class="offer_box-txt">{{ item.smallCategory }} {{ item.middleCategory }} {{ item.value }}</p>
                    </div>
                    <div class="offer_box-list">
                        <p class="offer_box-title">職種</p>
                        <p v-for="(item, index) in companyInfo.occupation" :key="index" class="offer_box-txt">{{ item.smallCategory }} {{ item.middleCategory }} {{ item.value }}</p>
                    </div>
                    <div class="text-center">
                        <el-button id="resend_secure" type="success" class="offer_box-acceptbtn"
                        @click="submitYagioffer()"
                          >まずは話を聞いてみる</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!--ここから下はログインフォーム-->
        <div class="text-center" v-if="!$firebase.isAuthenticated">
            <login-forms />
        </div>
    </section>
</div>

</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>

<style lang="scss" scoped>
    .offer_box-wrapper{
        padding: 0 20px;
    }

    .offer_box-wrapper .offer_box{
        margin-bottom: 30px;
    }

    .offer_box-wrapper .offer_box01{
        margin-bottom: 30px;
    }

    .offer_box-wrapper .offer_box-company{
        font-size: 18px;
    }

    .offer_box-wrapper .offer_box-img{
        height: 50px;
        width: auto;
        max-width: 100%;
    }

    .offer_box-wrapper .offer_box-list{
        text-align: left;
        margin-bottom: 20px;
    }

    .offer_box-wrapper .offer_box-title{
        font-size: 16px;
        font-weight: bold;
        color: #004D40;
    }

    .offer_box-wrapper .offer_box-message{
        background: #EDF5E8;
        border-radius: 10px;
        padding: 20px;
        text-align: left;
        margin-top: 10px;
    }

    .offer_box-wrapper .offer_box-pdf{
        display: flex;
        padding: 10px 20px;
        margin-bottom: 20px;
    }

    .offer_box-wrapper .offer_box-acceptbtn{
        background-color: rgb(227, 22, 92);
        border-color: rgb(227, 22, 92);
        color: rgb(255, 255, 255);
    }

</style>

<script>
// import LoginForms from '@/components/RenewLoginForms'
import LoginForms from '@/components/LoginSpecialForms'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  props: {
    offerUid: {
      type: String
    },
    uid: {
      type: String
    }
  },
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      fullscreenLoading: false,
      token: null,
      companyInfo:null
    }
  },
  computed: {
  },
  methods: {
    submitYagioffer: function() {

      const formData = new FormData()
      formData.append('uuid', this.uid)
      formData.append('offer_uid', this.offerUid)
      const app = this
      app.$axios.get(this.$varuna.endPoints.submitYagioffer, {
        params: {
          uuid: app.uid,
          offer_uid: app.offerUid
        }
      })
    }
    
  },
  created: function () {
  },
  beforeMount: function () {
    const app = this
    app.fullscreenLoading = true
    const formData = new FormData()
    formData.append('uuid', '-')
    formData.append('offer_uid', app.offerUid)

    this.$axios
      .post(this.$varuna.endPoints.getCompanyDetailInfo, formData, {timeout: 60000})
      .then(function (response) {
        app.companyInfo = response.data.company_info.data

      })
      .catch(function (error) {
      }).finally(function () {
        app.fullscreenLoading = false
      })
  },
  destroyed: function () {
  }
}
</script>
